<h2 mat-dialog-title [class.danger]="data.danger">{{ data.title }}</h2>

<mat-dialog-content>
  <p class="subtitle" *ngIf="data.entityName">
    <strong>{{ data.entityName }}</strong>
  </p>
  <p class="hint">This action is recorded in the audit log. Please choose a reason.</p>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Reason</mat-label>
    <mat-select [(ngModel)]="selectedPreset">
      <mat-option *ngFor="let r of presetReasons" [value]="r">{{ r }}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width" *ngIf="selectedPreset === 'Other'">
    <mat-label>Describe the reason</mat-label>
    <textarea matInput rows="3" [(ngModel)]="otherReason" placeholder="Why are you removing this?"></textarea>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button [color]="data.danger ? 'warn' : 'primary'"
    [disabled]="!isValid()" (click)="onConfirm()">
    {{ data.confirmLabel || 'Confirm' }}
  </button>
</mat-dialog-actions>
